import React from "react";
import { useNavigate } from "react-router-dom";
import '../../assets/css/style.css'

import UnlockBtn from '../../assets/img/unlock.svg'
import LockBtn from '../../assets/img/lock.svg'
import { useEffect } from "react";
import { useState } from "react";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const HomeDan = () => {
  const navigate = useNavigate(); 


const [refcount, setrefcount] = useState(0);



  
  useEffect(() => {
    const donetoken = localStorage.getItem("donetoken");
    if (donetoken) {
      // اگر توکن وجود دارد، وارد پنل شود
    }else{
      navigate("/");
    }
  }, [navigate]);


  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    
    if (userInfo) {

    setrefcount(userInfo.ref_count || 0);
   
  }
    
  }, []);





  const [sliders, setSliders] = useState([]);


  useEffect(() => {
    fetch("https://app.doneapp.ir/backend/home_slider.php") 
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setSliders(data.sliders);
        }
      })
      .catch((error) => console.error("Error fetching sliders:", error));
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };


  return (
   <>
  <div className="mohtava-mine" >
    
<section id="home" className="dir-r max-cntt-w" >
  
          <div className="p-8">
      <span className="f-700">
        برگزیده های دان</span>
      <span className="home-left-f" >
    مشاهده همه
    </span>
  </div>

  <Slider {...settings}>
      {sliders.map((slider) => (
        <div key={slider.post_id} className="home-slider-1">
          <img
            className="home-slider-img"
            src={`https://app.doneapp.ir/${slider.post_img}`}
            alt={slider.post_title}
          />
          <div className="home-slider-info">
            <h3>{slider.post_title}</h3>
           
            <button className="home-slider-btn-2"    >{slider.slider_btn}</button>
          </div>
        </div>
      ))}
    </Slider>



  
  <div id="steps" className="d-flex mt-20" >

          <div id="mohtavaha" className="home-mohtava-1" >
              
          <p className="home-step-1" >
          مرحله اول: قدردانی و آغاز دوستی!
          </p>
          <p className="home-p-title-1">
          با دعوت به عمل آوردن از ۳ نفر از دوستان خود، مبلغ واریزی اتان بابت خرید اشتراک دان به پاس قدردانی از حمایت شما به حسابتان بازخواهد گشت.
              </p>
              <p className="home-p-2" >
          مرحله دوم: کنسرت این ماه رو مهمون دان!
          </p>
          <p className="home-p-3" >
     مثل مرحله قبل در این مرحله با دعوت از ۳ نفر از دوستان خود دو بلیط رایگان کنسرت به عنوان جایزه تقدیم حضورتان می&zwnj;گردد.     
      </p>
      
      <button className="home-get-btn-1"  onClick={() => navigate("/panel/gifts")}  >
        دریافت کد دعوت انحصاری</button>
          
          </div>
          
          <div id="navarghofl" className="home-lock-line-1" >
      
          

<button className={refcount >= 2 ? "home-not-lock-btn" : "home-lock-btn"} >
<img src={refcount >= 2 ? UnlockBtn : LockBtn} alt="not lock" />
</button>

<button className={refcount >= 5 ? "home-not-lock-btn" : "home-lock-btn"} >
<img src={refcount >= 5 ? UnlockBtn : LockBtn} alt="locked" />
</button>

  </div>
          
          
          </div>





      <div className="h-100">
          
      </div>
  
      </section>

  </div>
   </>
      
  );
};

export default HomeDan;
